<script>
  let {
    assetsPath = '/',
    onAiMounted = () => {},
    onArtboardChange = () => {},
  } = $props();
  import { onMount, untrack } from 'svelte';
  let aiBox;
  let aiBoxWidth = $state(undefined);
  let allArtboards = $state([]);
  let activeArtboard = $state(undefined);
  onMount(() => {
    allArtboards = Array.from(aiBox.querySelectorAll('.g-artboard'));
    onAiMounted();
  });
  $effect(() => {
    if (aiBoxWidth) {
      const currentArtboard = allArtboards.filter((artboard) => {
        const minWidth = parseFloat(artboard.dataset.minWidth);
        const maxWidth = parseFloat(artboard.dataset.maxWidth) || Infinity;
        return minWidth <= aiBoxWidth && maxWidth >= aiBoxWidth;
      })[0];
      if (currentArtboard?.id !== activeArtboard?.id) {
        activeArtboard = untrack(() => currentArtboard);
        onArtboardChange(activeArtboard);
      }
    }
  });
</script>

<div
  id="g-post-8_before-after-box"
  class="ai2svelte"
  bind:this={aiBox}
  bind:clientWidth={aiBoxWidth}
>
  <!-- Artboard: xs -->
  <div
    id="g-post-8_before-after-xs"
    class="g-artboard"
    style="max-width: 509px;aspect-ratio: 0.16445462116091;"
    data-aspect-ratio="0.164"
    data-min-width="0"
    data-max-width="509"
  >
    <div
      id="g-post-8_before-after-xs-img"
      class="g-post-8_before-after-xs-img g-aiImg"
      alt=""
      style="background-image: url({assetsPath.replace(
        new RegExp('/([^/.]+)$'),
        '/$1/'
      ) || '/'}images/graphics/post-8_before-after-xs.jpg);"
    ></div>
    <div
      id="g-ai0-15"
      class="g-text g-aiAbs g-aiPointText"
      style="top:79.5667%;margin-top:-6.6px;left:0.9727%;width:63px;"
    >
      <p class="g-pstyle2">Jan. 18</p>
    </div>
    <div
      id="g-ai0-3"
      class="g-text g-aiAbs g-aiPointText"
      style="top:1.6537%;margin-top:-6.6px;left:0.989%;width:66px;"
    >
      <p class="g-pstyle2">Feb. 22</p>
    </div>
    <div
      id="g-ai0-14"
      class="g-text g-aiAbs g-aiPointText"
      style="top:78.2765%;margin-top:-10.2px;left:0.0001%;width:212px;"
    >
      <p class="g-pstyle0">National Defense University</p>
    </div>
    <div
      id="g-ai0-13"
      class="g-text g-aiAbs g-aiPointText"
      style="top:64.9992%;margin-top:-6.6px;left:0.8377%;width:73px;"
    >
      <p class="g-pstyle2">March 3</p>
    </div>
    <div
      id="g-ai0-12"
      class="g-text g-aiAbs g-aiPointText"
      style="top:52.4621%;margin-top:-6.6px;left:0.9727%;width:65px;"
    >
      <p class="g-pstyle2">Feb. 27</p>
    </div>
    <div
      id="g-ai0-7"
      class="g-text g-aiAbs g-aiPointText"
      style="top:13.5818%;margin-top:-6.6px;left:0.912%;width:73px;"
    >
      <p class="g-pstyle2">March 3</p>
    </div>
    <div
      id="g-ai0-8"
      class="g-text g-aiAbs g-aiPointText"
      style="top:26.3008%;margin-top:-10.2px;left:-0.0469%;width:144px;"
    >
      <p class="g-pstyle0">Judiciary complex</p>
    </div>
    <div
      id="g-ai0-9"
      class="g-text g-aiAbs g-aiPointText"
      style="top:27.5401%;margin-top:-6.6px;left:0.9257%;width:68px;"
    >
      <p class="g-pstyle2">March 1</p>
    </div>
    <div
      id="g-ai0-10"
      class="g-text g-aiAbs g-aiPointText"
      style="top:38.5038%;margin-top:-6.6px;left:0.8714%;width:73px;"
    >
      <p class="g-pstyle2">March 3</p>
    </div>
    <div
      id="g-ai0-11"
      class="g-text g-aiAbs g-aiPointText"
      style="top:50.7456%;margin-top:-19.8px;left:0.0001%;width:310px;"
    >
      <p class="g-pstyle0">Headquarters of the Islamic Revolutionary</p>
      <p class="g-pstyle0">Guards Corps (IRGC)</p>
    </div>
    <div
      id="g-ai0-16"
      class="g-text g-aiAbs g-aiPointText"
      style="top:90.1242%;margin-top:-6.6px;left:0.8377%;width:73px;"
    >
      <p class="g-pstyle2">March 3</p>
    </div>
    <div
      id="g-ai0-1"
      class="g-text g-aiAbs g-aiPointText"
      style="top:0.4144%;margin-top:-10.2px;left:0.0163%;width:337px;"
    >
      <p class="g-pstyle0">Khamenei residence and presidential complex</p>
    </div>
    <div
      id="g-ai0-5"
      class="g-anno g-aiAbs g-aiPointText"
      style="top:6.6229%;margin-top:-17.5px;left:16.007%;width:99px;"
    >
      <p class="g-pstyle1">Government</p>
      <p class="g-pstyle1">building</p>
    </div>
    <div
      id="g-ai0-4"
      class="g-anno g-aiAbs g-aiPointText"
      style="top:6.095%;margin-top:-9.1px;left:71.7929%;width:69px;"
    >
      <p class="g-pstyle1">Mosque</p>
    </div>
    <div
      id="g-ai0-2"
      class="g-anno g-aiAbs g-aiPointText"
      style="top:2.5623%;margin-top:-17.5px;left:64.0642%;width:88px;"
    >
      <p class="g-pstyle1">House of</p>
      <p class="g-pstyle1">Leadership</p>
    </div>
    <div
      id="g-ai0-6"
      class="g-anno g-aiAbs g-aiPointText"
      style="top:8.3537%;margin-top:-14.6px;right:32.9652%;width:94px;"
    >
      <p class="g-pstyle3">Presidential</p>
      <p class="g-pstyle3">office</p>
    </div>
  </div>
  <!-- Artboard: sm -->
  <div
    id="g-post-8_before-after-sm"
    class="g-artboard"
    style="min-width: 510px;max-width: 659px;aspect-ratio: 0.64065740725666;"
    data-aspect-ratio="0.641"
    data-min-width="510"
    data-max-width="659"
  >
    <div
      id="g-post-8_before-after-sm-img"
      class="g-post-8_before-after-sm-img g-aiImg"
      alt=""
      style="background-image: url({assetsPath.replace(
        new RegExp('/([^/.]+)$'),
        '/$1/'
      ) || '/'}images/graphics/post-8_before-after-sm.jpg);"
    ></div>
    <div
      id="g-ai1-16"
      class="g-text g-aiAbs g-aiPointText"
      style="top:81.0869%;margin-top:-5.5px;left:0.4215%;width:57px;"
    >
      <p class="g-pstyle2">Jan. 18</p>
    </div>
    <div
      id="g-ai1-3"
      class="g-text g-aiAbs g-aiPointText"
      style="top:3.203%;margin-top:-5.5px;left:0.4215%;width:60px;"
    >
      <p class="g-pstyle2">Feb. 22</p>
    </div>
    <div
      id="g-ai1-4"
      class="g-text g-aiAbs g-aiPointText"
      style="top:3.203%;margin-top:-5.5px;left:51.2688%;width:66px;"
    >
      <p class="g-pstyle2">March 3</p>
    </div>
    <div
      id="g-ai1-15"
      class="g-text g-aiAbs g-aiPointText"
      style="top:78.6477%;margin-top:-9.1px;left:-0.0563%;width:188px;"
    >
      <p class="g-pstyle0">National Defense University</p>
    </div>
    <div
      id="g-ai1-14"
      class="g-text g-aiAbs g-aiPointText"
      style="top:53.8275%;margin-top:-5.5px;left:51.2688%;width:66px;"
    >
      <p class="g-pstyle2">March 3</p>
    </div>
    <div
      id="g-ai1-13"
      class="g-text g-aiAbs g-aiPointText"
      style="top:53.8275%;margin-top:-5.5px;left:0.4215%;width:59px;"
    >
      <p class="g-pstyle2">Feb. 27</p>
    </div>
    <div
      id="g-ai1-12"
      class="g-text g-aiAbs g-aiPointText"
      style="top:51.2628%;margin-top:-9.1px;left:-0.0563%;width:400px;"
    >
      <p class="g-pstyle0">
        Headquarters of the Islamic Revolutionary Guards Corps (IRGC)
      </p>
    </div>
    <div
      id="g-ai1-9"
      class="g-text g-aiAbs g-aiPointText"
      style="top:27.0183%;margin-top:-9.1px;left:-0.0563%;width:129px;"
    >
      <p class="g-pstyle0">Judiciary complex</p>
    </div>
    <div
      id="g-ai1-10"
      class="g-text g-aiAbs g-aiPointText"
      style="top:29.4574%;margin-top:-5.5px;left:0.4215%;width:61px;"
    >
      <p class="g-pstyle2">March 1</p>
    </div>
    <div
      id="g-ai1-11"
      class="g-text g-aiAbs g-aiPointText"
      style="top:29.4574%;margin-top:-5.5px;left:51.2688%;width:66px;"
    >
      <p class="g-pstyle2">March 3</p>
    </div>
    <div
      id="g-ai1-17"
      class="g-text g-aiAbs g-aiPointText"
      style="top:81.0869%;margin-top:-5.5px;left:51.2688%;width:66px;"
    >
      <p class="g-pstyle2">March 3</p>
    </div>
    <div
      id="g-ai1-1"
      class="g-text g-aiAbs g-aiPointText"
      style="top:0.7639%;margin-top:-9.1px;left:-0.0563%;width:297px;"
    >
      <p class="g-pstyle0">Khamenei residence and presidential complex</p>
    </div>
    <div
      id="g-ai1-7"
      class="g-anno g-aiAbs g-aiPointText"
      style="top:16.1418%;margin-top:-12.5px;right:67.0783%;width:84px;"
    >
      <p class="g-pstyle3">Presidential</p>
      <p class="g-pstyle3">office</p>
    </div>
    <div
      id="g-ai1-6"
      class="g-anno g-aiAbs g-aiPointText"
      style="top:12.6245%;margin-top:-12.5px;left:7.7994%;width:88px;"
    >
      <p class="g-pstyle1">Government</p>
      <p class="g-pstyle1">building</p>
    </div>
    <div
      id="g-ai1-5"
      class="g-anno g-aiAbs g-aiPointText"
      style="top:11.7451%;margin-top:-6.5px;left:35.2051%;width:63px;"
    >
      <p class="g-pstyle1">Mosque</p>
    </div>
    <div
      id="g-ai1-2"
      class="g-anno g-aiAbs g-aiPointText"
      style="top:4.8361%;margin-top:-12.5px;left:31.4082%;width:79px;"
    >
      <p class="g-pstyle1">House of</p>
      <p class="g-pstyle1">Leadership</p>
    </div>
    <div
      id="g-ai1-8"
      class="g-anno g-aiAbs g-aiPointText"
      style="top:19.031%;margin-top:-12.5px;left:39.0864%;width:75px;"
    >
      <p class="g-pstyle1">Damaged</p>
      <p class="g-pstyle1">buildings</p>
    </div>
  </div>
  <!-- Artboard: md -->
  <div
    id="g-post-8_before-after-md"
    class="g-artboard"
    style="min-width: 660px;max-width: 910px;aspect-ratio: 0.6411637356942;"
    data-aspect-ratio="0.641"
    data-min-width="660"
    data-max-width="910"
  >
    <div
      id="g-post-8_before-after-md-img"
      class="g-post-8_before-after-md-img g-aiImg"
      alt=""
      style="background-image: url({assetsPath.replace(
        new RegExp('/([^/.]+)$'),
        '/$1/'
      ) || '/'}images/graphics/post-8_before-after-md.jpg);"
    ></div>
    <div
      id="g-ai2-16"
      class="g-text g-aiAbs g-aiPointText"
      style="top:81.0762%;margin-top:-6.6px;left:0.4775%;width:63px;"
    >
      <p class="g-pstyle2">Jan. 18</p>
    </div>
    <div
      id="g-ai2-3"
      class="g-text g-aiAbs g-aiPointText"
      style="top:3.2623%;margin-top:-6.6px;left:0.4775%;width:66px;"
    >
      <p class="g-pstyle2">Feb. 22</p>
    </div>
    <div
      id="g-ai2-4"
      class="g-text g-aiAbs g-aiPointText"
      style="top:3.2623%;margin-top:-6.6px;left:51.2879%;width:73px;"
    >
      <p class="g-pstyle2">March 3</p>
    </div>
    <div
      id="g-ai2-15"
      class="g-text g-aiAbs g-aiPointText"
      style="top:78.7042%;margin-top:-10.2px;left:0%;width:212px;"
    >
      <p class="g-pstyle0">National Defense University</p>
    </div>
    <div
      id="g-ai2-14"
      class="g-text g-aiAbs g-aiPointText"
      style="top:53.7782%;margin-top:-6.6px;left:51.2879%;width:73px;"
    >
      <p class="g-pstyle2">March 3</p>
    </div>
    <div
      id="g-ai2-13"
      class="g-text g-aiAbs g-aiPointText"
      style="top:53.7782%;margin-top:-6.6px;left:0.4775%;width:65px;"
    >
      <p class="g-pstyle2">Feb. 27</p>
    </div>
    <div
      id="g-ai2-12"
      class="g-text g-aiAbs g-aiPointText"
      style="top:51.309%;margin-top:-10.2px;left:0%;width:454px;"
    >
      <p class="g-pstyle0">
        Headquarters of the Islamic Revolutionary Guards Corps (IRGC)
      </p>
    </div>
    <div
      id="g-ai2-9"
      class="g-text g-aiAbs g-aiPointText"
      style="top:27.0225%;margin-top:-10.2px;left:0%;width:144px;"
    >
      <p class="g-pstyle0">Judiciary complex</p>
    </div>
    <div
      id="g-ai2-10"
      class="g-text g-aiAbs g-aiPointText"
      style="top:29.4917%;margin-top:-6.6px;left:0.4775%;width:68px;"
    >
      <p class="g-pstyle2">March 1</p>
    </div>
    <div
      id="g-ai2-11"
      class="g-text g-aiAbs g-aiPointText"
      style="top:29.4917%;margin-top:-6.6px;left:51.2879%;width:73px;"
    >
      <p class="g-pstyle2">March 3</p>
    </div>
    <div
      id="g-ai2-17"
      class="g-text g-aiAbs g-aiPointText"
      style="top:81.0762%;margin-top:-6.6px;left:51.2879%;width:73px;"
    >
      <p class="g-pstyle2">March 3</p>
    </div>
    <div
      id="g-ai2-1"
      class="g-text g-aiAbs g-aiPointText"
      style="top:0.8902%;margin-top:-10.2px;left:0%;width:337px;"
    >
      <p class="g-pstyle0">Khamenei residence and presidential complex</p>
    </div>
    <div
      id="g-ai2-7"
      class="g-anno g-aiAbs g-aiPointText"
      style="top:16.0855%;margin-top:-14.6px;right:67.1001%;width:94px;"
    >
      <p class="g-pstyle3">Presidential</p>
      <p class="g-pstyle3">office</p>
    </div>
    <div
      id="g-ai2-6"
      class="g-anno g-aiAbs g-aiPointText"
      style="top:12.7729%;margin-top:-17.5px;left:7.8499%;width:99px;"
    >
      <p class="g-pstyle1">Government</p>
      <p class="g-pstyle1">building</p>
    </div>
    <div
      id="g-ai2-5"
      class="g-anno g-aiAbs g-aiPointText"
      style="top:11.7625%;margin-top:-9.1px;left:35.2357%;width:69px;"
    >
      <p class="g-pstyle1">Mosque</p>
    </div>
    <div
      id="g-ai2-2"
      class="g-anno g-aiAbs g-aiPointText"
      style="top:4.904%;margin-top:-17.5px;left:31.4418%;width:88px;"
    >
      <p class="g-pstyle1">House of</p>
      <p class="g-pstyle1">Leadership</p>
    </div>
    <div
      id="g-ai2-8"
      class="g-anno g-aiAbs g-aiPointText"
      style="top:18.9188%;margin-top:-12.7px;left:39.1146%;width:84px;"
    >
      <p class="g-pstyle2">Damaged</p>
      <p class="g-pstyle2">buildings</p>
    </div>
  </div>
  <!-- Artboard: lg -->
  <div
    id="g-post-8_before-after-lg"
    class="g-artboard"
    style="min-width: 911px;aspect-ratio: 0.64119168923714;"
    data-aspect-ratio="0.641"
    data-min-width="911"
  >
    <div
      id="g-post-8_before-after-lg-img"
      class="g-post-8_before-after-lg-img g-aiImg"
      alt=""
      style="background-image: url({assetsPath.replace(
        new RegExp('/([^/.]+)$'),
        '/$1/'
      ) || '/'}images/graphics/post-8_before-after-lg.jpg);"
    ></div>
    <div
      id="g-ai3-2"
      class="g-text g-aiAbs g-aiPointText"
      style="top:3.1084%;margin-top:-9.2px;left:0.5867%;width:72px;"
    >
      <p class="g-pstyle1">Feb. 22</p>
    </div>
    <div
      id="g-ai3-3"
      class="g-text g-aiAbs g-aiPointText"
      style="top:3.1084%;margin-top:-9.2px;left:51.3399%;width:80px;"
    >
      <p class="g-pstyle1">March 3</p>
    </div>
    <div
      id="g-ai3-16"
      class="g-text g-aiAbs g-aiPointText"
      style="top:80.8819%;margin-top:-9.2px;left:0.5867%;width:68px;"
    >
      <p class="g-pstyle1">Jan. 18</p>
    </div>
    <div
      id="g-ai3-15"
      class="g-text g-aiAbs g-aiPointText"
      style="top:78.4596%;margin-top:-11.7px;left:0.1098%;width:236px;"
    >
      <p class="g-pstyle0">National Defense University</p>
    </div>
    <div
      id="g-ai3-14"
      class="g-text g-aiAbs g-aiPointText"
      style="top:53.6436%;margin-top:-9.2px;left:51.3399%;width:80px;"
    >
      <p class="g-pstyle1">March 3</p>
    </div>
    <div
      id="g-ai3-13"
      class="g-text g-aiAbs g-aiPointText"
      style="top:53.6436%;margin-top:-9.2px;left:0.5867%;width:72px;"
    >
      <p class="g-pstyle1">Feb. 27</p>
    </div>
    <div
      id="g-ai3-12"
      class="g-text g-aiAbs g-aiPointText"
      style="top:51.1508%;margin-top:-11.7px;left:0.1098%;width:508px;"
    >
      <p class="g-pstyle0">
        Headquarters of the Islamic Revolutionary Guards Corps (IRGC)
      </p>
    </div>
    <div
      id="g-ai3-9"
      class="g-text g-aiAbs g-aiPointText"
      style="top:26.8686%;margin-top:-11.7px;left:0.1098%;width:159px;"
    >
      <p class="g-pstyle0">Judiciary complex</p>
    </div>
    <div
      id="g-ai3-10"
      class="g-text g-aiAbs g-aiPointText"
      style="top:29.291%;margin-top:-9.2px;left:0.5867%;width:75px;"
    >
      <p class="g-pstyle1">March 1</p>
    </div>
    <div
      id="g-ai3-11"
      class="g-text g-aiAbs g-aiPointText"
      style="top:29.291%;margin-top:-9.2px;left:51.3399%;width:80px;"
    >
      <p class="g-pstyle1">March 3</p>
    </div>
    <div
      id="g-ai3-17"
      class="g-text g-aiAbs g-aiPointText"
      style="top:80.8819%;margin-top:-9.2px;left:51.3399%;width:80px;"
    >
      <p class="g-pstyle1">March 3</p>
    </div>
    <div
      id="g-ai3-1"
      class="g-text g-aiAbs g-aiPointText"
      style="top:0.7564%;margin-top:-11.7px;left:0.1098%;width:376px;"
    >
      <p class="g-pstyle0">Khamenei residence and presidential complex</p>
    </div>
    <div
      id="g-ai3-7"
      class="g-anno g-aiAbs g-aiPointText"
      style="top:16.0812%;margin-top:-17.5px;right:67.0226%;width:94px;"
    >
      <p class="g-pstyle4">Presidential</p>
      <p class="g-pstyle4">office</p>
    </div>
    <div
      id="g-ai3-6"
      class="g-anno g-aiAbs"
      style="top:11.3317%;left:9.6032%;width:8.4523%;"
    >
      <p class="g-pstyle3">Government</p>
      <p class="g-pstyle3">building</p>
    </div>
    <div
      id="g-ai3-5"
      class="g-anno g-aiAbs g-aiPointText"
      style="top:11.8301%;margin-top:-9.1px;left:36.7129%;width:69px;"
    >
      <p class="g-pstyle2">Mosque</p>
    </div>
    <div
      id="g-ai3-4"
      class="g-anno g-aiAbs g-aiPointText"
      style="top:5.1014%;margin-top:-17.5px;left:35.6249%;width:88px;"
    >
      <p class="g-pstyle2">House of</p>
      <p class="g-pstyle2">Leadership</p>
    </div>
    <div
      id="g-ai3-8"
      class="g-anno g-aiAbs"
      style="top:17.3143%;left:40.0974%;width:6.6959%;"
    >
      <p class="g-pstyle3">Damaged</p>
      <p class="g-pstyle3">buildings</p>
    </div>
  </div>
</div>

<!-- End ai2svelte - 2026-03-04 15:45 -->

<!-- Generated by ai2svelte v1.0.3 - 2026-03-04 15:45 -->
<!-- ai file: post-8_before-after.ai -->
<style lang="scss">
  #g-post-8_before-after-box {
    container-type: inline-size;
    container-name: g-post-8_before-after-box;
  }
  #g-post-8_before-after-box,
  #g-post-8_before-after-box .g-artboard {
    margin: 0 auto;
  }
  #g-post-8_before-after-box p {
    margin: 0;
  }
  #g-post-8_before-after-box .g-aiAbs {
    position: absolute;
  }
  #g-post-8_before-after-box .g-aiImg {
    position: absolute;
    top: 0;
    display: block;
    width: 100% !important;
    height: 100%;
    background-size: contain;
    background-repeat: no-repeat;
  }
  #g-post-8_before-after-box .g-aiSymbol {
    position: absolute;
    box-sizing: border-box;
  }
  #g-post-8_before-after-box .g-aiPointText p {
    white-space: nowrap;
  }
  #g-post-8_before-after-box.g-aiPointText p {
    white-space: nowrap;
  }
  #g-post-8_before-after-box {
    width: 100%;
    container-type: inline-size;
    @container (min-width:0px) and (max-width: 509px) {
      #g-post-8_before-after-xs {
        display: block !important;
      }
    }
    @container (min-width:510px) and (max-width: 659px) {
      #g-post-8_before-after-sm {
        display: block !important;
      }
    }
    @container (min-width:660px) and (max-width: 910px) {
      #g-post-8_before-after-md {
        display: block !important;
      }
    }
    @container (min-width:911px) {
      #g-post-8_before-after-lg {
        display: block !important;
      }
    }
  }
  #g-post-8_before-after-xs {
    position: relative;
    overflow: hidden;
    display: none;
  }
  #g-post-8_before-after-xs p {
    font-family: var(--theme-font-family-sans-serif), Knowledge, sans-serif;
    font-weight: regular;
    line-height: 19px;
    height: auto;
    opacity: 1;
    letter-spacing: 0em;
    font-size: 16px;
    text-align: left;
    color: rgb(0, 0, 0);
    text-transform: none;
    padding-bottom: 0;
    padding-top: 0;
    mix-blend-mode: normal;
    font-style: normal;
    position: static;
  }
  #g-post-8_before-after-xs .g-pstyle0 {
    font-weight: 500;
    height: 19px;
  }
  #g-post-8_before-after-xs .g-pstyle1 {
    font-weight: 500;
    line-height: 17px;
    height: 17px;
    font-size: 14px;
    color: rgb(255, 255, 255);
  }
  #g-post-8_before-after-xs .g-pstyle2 {
    font-weight: 500;
    line-height: 12px;
    height: 12px;
    font-size: 14px;
    color: rgb(255, 255, 255);
  }
  #g-post-8_before-after-xs .g-pstyle3 {
    font-weight: 500;
    line-height: 14px;
    height: 14px;
    font-size: 14px;
    text-align: right;
    color: rgb(255, 255, 255);
  }
  #g-post-8_before-after-sm {
    position: relative;
    overflow: hidden;
    display: none;
  }
  #g-post-8_before-after-sm p {
    font-family: var(--theme-font-family-sans-serif), Knowledge, sans-serif;
    font-weight: regular;
    line-height: 17px;
    height: auto;
    opacity: 1;
    letter-spacing: 0em;
    font-size: 14px;
    text-align: left;
    color: rgb(0, 0, 0);
    text-transform: none;
    padding-bottom: 0;
    padding-top: 0;
    mix-blend-mode: normal;
    font-style: normal;
    position: static;
  }
  #g-post-8_before-after-sm .g-pstyle0 {
    font-weight: 500;
    height: 17px;
  }
  #g-post-8_before-after-sm .g-pstyle1 {
    font-weight: 500;
    line-height: 12px;
    height: 12px;
    font-size: 12px;
    color: rgb(255, 255, 255);
  }
  #g-post-8_before-after-sm .g-pstyle2 {
    font-weight: 500;
    line-height: 10px;
    height: 10px;
    font-size: 12px;
    color: rgb(255, 255, 255);
  }
  #g-post-8_before-after-sm .g-pstyle3 {
    font-weight: 500;
    line-height: 12px;
    height: 12px;
    font-size: 12px;
    text-align: right;
    color: rgb(255, 255, 255);
  }
  #g-post-8_before-after-md {
    position: relative;
    overflow: hidden;
    display: none;
  }
  #g-post-8_before-after-md p {
    font-family: var(--theme-font-family-sans-serif), Knowledge, sans-serif;
    font-weight: regular;
    line-height: 19px;
    height: auto;
    opacity: 1;
    letter-spacing: 0em;
    font-size: 16px;
    text-align: left;
    color: rgb(0, 0, 0);
    text-transform: none;
    padding-bottom: 0;
    padding-top: 0;
    mix-blend-mode: normal;
    font-style: normal;
    position: static;
  }
  #g-post-8_before-after-md .g-pstyle0 {
    font-weight: 500;
    height: 19px;
  }
  #g-post-8_before-after-md .g-pstyle1 {
    font-weight: 500;
    line-height: 17px;
    height: 17px;
    font-size: 14px;
    color: rgb(255, 255, 255);
  }
  #g-post-8_before-after-md .g-pstyle2 {
    font-weight: 500;
    line-height: 12px;
    height: 12px;
    font-size: 14px;
    color: rgb(255, 255, 255);
  }
  #g-post-8_before-after-md .g-pstyle3 {
    font-weight: 500;
    line-height: 14px;
    height: 14px;
    font-size: 14px;
    text-align: right;
    color: rgb(255, 255, 255);
  }
  #g-post-8_before-after-lg {
    position: relative;
    overflow: hidden;
    display: none;
  }
  #g-post-8_before-after-lg p {
    font-family: var(--theme-font-family-sans-serif), Knowledge, sans-serif;
    font-weight: regular;
    line-height: 22px;
    height: auto;
    opacity: 1;
    letter-spacing: 0em;
    font-size: 18px;
    text-align: left;
    color: rgb(0, 0, 0);
    text-transform: none;
    padding-bottom: 0;
    padding-top: 0;
    mix-blend-mode: normal;
    font-style: normal;
    position: static;
  }
  #g-post-8_before-after-lg .g-pstyle0 {
    font-weight: 500;
    height: 22px;
  }
  #g-post-8_before-after-lg .g-pstyle1 {
    font-weight: 500;
    line-height: 17px;
    height: 17px;
    font-size: 16px;
    color: rgb(255, 255, 255);
  }
  #g-post-8_before-after-lg .g-pstyle2 {
    font-weight: 500;
    line-height: 17px;
    height: 17px;
    font-size: 14px;
    color: rgb(255, 255, 255);
  }
  #g-post-8_before-after-lg .g-pstyle3 {
    font-weight: 500;
    line-height: 17px;
    font-size: 14px;
    color: rgb(255, 255, 255);
  }
  #g-post-8_before-after-lg .g-pstyle4 {
    font-weight: 500;
    line-height: 17px;
    height: 17px;
    font-size: 14px;
    text-align: right;
    color: rgb(255, 255, 255);
  }

  /* Custom CSS */
  @mixin shadow-manchego($clr) {
    $alpha: if(alpha($clr) != 1, alpha($clr), 1);
    text-shadow:
      rgba($clr, $alpha) 1px 0px 0px,
      rgba($clr, $alpha) 0.540302px 0.841471px 0px,
      rgba($clr, $alpha) -0.416147px 0.909297px 0px,
      rgba($clr, $alpha) -0.989992px 0.14112px 0px,
      rgba($clr, $alpha) -0.653644px -0.756802px 0px,
      rgba($clr, $alpha) 0.283662px -0.958924px 0px,
      rgba($clr, $alpha) 0.96017px -0.279415px 0px;
  }

  @mixin shadow-feta($clr) {
    $alpha: if(alpha($clr) != 1, alpha($clr), 0.5);
    text-shadow:
      0 0 10px rgba($clr, $alpha),
      0 0 3px rgba($clr, $alpha);
  }

  @mixin shadow-provolone($clr) {
    $alpha: if(alpha($clr) != 1, alpha($clr), 0.7);
    text-shadow:
      1px 1px 0px rgba($clr, $alpha),
      0px 1px 0px rgba($clr, $alpha),
      -1px 1px 0px rgba($clr, $alpha),
      -1px 0px 0px rgba($clr, $alpha),
      -1px -1px 0px rgba($clr, $alpha),
      0px -1px 0px rgba($clr, $alpha),
      1px -1px 0px rgba($clr, $alpha);
  }

  @mixin shadow-gouda($clr) {
    $alpha: if(alpha($clr) != 1, alpha($clr), 0.9);
    text-shadow:
      1px 1px 1px rgba($clr, $alpha),
      1px -1px 1px rgba($clr, $alpha),
      -1px 1px 1px rgba($clr, $alpha),
      -1px -1px 1px rgba($clr, $alpha);
  }
  .g-shadow {
    @include shadow-manchego(#000000);
    @include shadow-feta(#000000);
  }
  .g-whiteshadow {
    @include shadow-provolone(#ffffff);
    @include shadow-gouda(#ffffff);
  }
  .g-anno {
    @include shadow-manchego(#000000);
  }
</style>
